import wethIcon from "../../../media/icons/weth.png";

export function WETHIcon() {
    return (
        <img src={wethIcon} width={40} height={40} alt='WETH'/>
    )
}
